import * as React from 'react';

import { PromotionContainer } from 'modules/shared-cms-advanced';
import { ProductThumbnail } from 'modules/catalogue/components';
import { NoveltiesCatalogueBlocContainerProps } from '.';

export const NoveltiesCatalogueBlocContainer: React.FC<NoveltiesCatalogueBlocContainerProps> = ({
    noveltiesSuperTitle,
    noveltiesTitle,
    noveltiesFontSizeTitle,
    noveltiesTitleClassName,
    noveltiesSubTitle,
    noveltiesFontSizeSubTitle,
    noveltiesTextColor,
    noveltiesCtaText,
    noveltiesCtaLink,
    noveltiesCtaStyle,
    noveltiesBackgroundColor,
    products,
}: NoveltiesCatalogueBlocContainerProps) => {
    if (products.length > 0) {
        return (
            <PromotionContainer
                promotionSuperTitle={noveltiesSuperTitle}
                promotionTitle={noveltiesTitle}
                promotionFontSizeTitle={noveltiesFontSizeTitle}
                promotionTitleClassName={noveltiesTitleClassName}
                promotionSubTitle={noveltiesSubTitle}
                promotionFontSizeSubTitle={noveltiesFontSizeSubTitle}
                promotionTextColor={noveltiesTextColor}
                promotionCtaText={noveltiesCtaText}
                promotionCtaLink={noveltiesCtaLink}
                promotionCtaStyle={noveltiesCtaStyle}
                promotionBackgroundColor={noveltiesBackgroundColor}
                promotionsItems={[]}
            >
                {products.map((product, index) => {
                    // eslint-disable-next-line react/no-array-index-key
                    return <ProductThumbnail key={`${product.id}-${index}`} product={product} centerLabels />;
                })}
            </PromotionContainer>
        );
    }

    return <React.Fragment />;
};
